export const attendanceAreaPathName = 'attendance';
export const attendanceCoursesAreaPathName = 'courses';
export const attendanceCourseMenuName = 'Hold';
export const attendanceCoursePath = 'courses/course/:courseId?';
export const attendanceLessonPath = 'lessons/lesson/:lessonId?';
export const attendanceLessonProtocolPath = 'lessons/lesson/:lessonId/protocol';
export const attendanceCitizenLessonDeviationPath = 'lessons/citizen-lesson-deviation/:citizenId/:citizenLessonDeviationId?';
export const attendanceEducatorsPathName = 'educators';
export const attendanceEducatorPath = 'educators/educator/:educatorId?';
export const attendanceClassroomsPathName = 'classrooms';
export const attendanceClassroomPath = 'classrooms/classroom/:classroomId?';
export const attendanceRegistrationCountersPathName = 'registration-counters';
export const attendanceRegistrationCounterPath = 'registration-counters/registration-counter/:registrationCounterId?';
export const attendanceBulkPath = 'bulk-course-enrollment';
export const attendanceCourseEnrollmentPath = ':citizenId/course-enrollment/:courseEnrollmentId?';
export const attendanceCitizenImport = 'attendance-import';
export const attendancePrintSchedulePathName = ':citizenId/print-schedule';
export const attendanceSendSchedulePathName = ':citizenId/send-schedule';
export const attendanceStatisticsPathName = ':citizenId/statistic';
export const attendanceCourseStatisticsPath = 'courses/course/:courseId/statistic';

export function getCourseRedirectPath() {
  return attendanceCoursePath.replace('/:courseId?', '');
}

export function getCourseEditPath(courseId: string) {
  return attendanceCoursePath.replace(':courseId?', courseId);
}

export function getLessonRedirectPath() {
  return attendanceLessonPath.replace('/:lessonId?', '');
}

export function getLessonEditPath(lessonId: string) {
  return attendanceLessonPath.replace(':lessonId?', lessonId);
}

export function getLessonProtocolPath(lessonId: string) {
  return attendanceLessonProtocolPath.replace(':lessonId', lessonId);
}

export function getEducatorRedirectPath() {
  return attendanceEducatorPath.replace('/:educatorId?', '');
}

export function getEducatorEditPath(educatorId: string) {
  return attendanceEducatorPath.replace(':educatorId?', educatorId);
}

export function getClassroomCreatePath() {
  return attendanceClassroomPath.replace('/:classroomId?', '');
}

export function getClassroomEditPath(classroomId: string) {
  return attendanceClassroomPath.replace(':classroomId?', classroomId);
}

export function getRegistrationCounterCreatePath() {
  return attendanceRegistrationCounterPath.replace('/:registrationCounterId?', '');
}

export function getRegistrationCounterEditPath(registrationCounterId: string) {
  return attendanceRegistrationCounterPath.replace(':registrationCounterId?', registrationCounterId);
}

export function getCourseEnrollmentRedirectPath(citizenId: string) {
  return attendanceCourseEnrollmentPath.replace(':citizenId', citizenId).replace('/:courseEnrollmentId?', '');
}

export function getCourseEnrollmentEditPath(citizenId: string, courseEnrollmentId: string) {
  return attendanceCourseEnrollmentPath.replace(':citizenId', citizenId).replace(':courseEnrollmentId?', courseEnrollmentId);
}

export function getCitizenLessonDeviationCreatePath(lessonId: string, citizenId: string, courseEnrollmentId: string) {
  const base = attendanceCitizenLessonDeviationPath.replace(':citizenId', citizenId).replace(':citizenLessonDeviationId?', '');
  return `${base}?lessonid=${lessonId}&courseenrollmentid=${courseEnrollmentId}`;
}

export function getCitizenLessonDeviationEditPath(citizenLessonDeviationId: string, citizenId: string) {
  return attendanceCitizenLessonDeviationPath.replace(':citizenLessonDeviationId?', citizenLessonDeviationId).replace(':citizenId', citizenId);
}

export function getAttendancePrintSchedulePath(citizenId: string) {
  return attendancePrintSchedulePathName.replace(':citizenId', citizenId);
}

export function getAttendanceSendSchedulePath(citizenId: string) {
  return attendanceSendSchedulePathName.replace(':citizenId', citizenId);
}

export function getAttendanceStatisticsPath(citizenId: string) {
  return attendanceStatisticsPathName.replace(':citizenId', citizenId);
}

export function getCourseAttendanceStatisticsPath(courseId: string) {
  return attendanceCourseStatisticsPath.replace(':courseId', courseId);
}
